import anime from "animejs";
import React, { useState } from "react";
import "./wheel.css";

const RouletteWheel = () => {
  return (
    <div className="flex 2xl:scale-100   lg:scale-[0.80]  xs:scale-[0.70] scale-[0.66]  flex-col">
      <div className={"roulette-wheel"}>
        <div
          className={"layer-2 wheel"}
          style={{ transform: "rotate(0deg)" }}
        ></div>
        <div className={"layer-3"}></div>
        <div
          className={"layer-4 wheel"}
          style={{ transform: "rotate(0deg)" }}
        ></div>
        <div className={"layer-5"}></div>
        <div className={"ball-container"} style={{ transform: "rotate(0deg)" }}>
          <div
            className={"ball"}
            style={{ transform: "translate(0, -163.221px)" }}
          ></div>
        </div>
      </div>
      <div className="flex items-center gap-x-4"></div>
    </div>
  );
};

export default RouletteWheel;
